<template>
  <div
    id="app"
    class="min-h-full font-sans">
    <div class="container mx-auto px-4 max-w-lg">
      <header
        class="w-full text-gray-600 flex py-8 justify-between">
        <div>
          <figure class="logo" />
        </div>
      </header>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    isHome () {
      return this.$route.name === "home"
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/tailwind.css";
  @import "./assets/app.scss";
</style>

<style lang="scss" scoped>
  .logo {
    background: url('~@/assets/images/logo-panther.svg') center center no-repeat;
    width: 87px;
    height: 26px;
    display: block;
  }
</style>
